import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { closeOrderWindow, updateOrderWindowType } from '../../store/actions/orders';
import OrderWindow from './OrderWindow';
import BrokerageAcknowledgmentDialog from './BrokerageAcknowledgmentDialog';

const OrderWindowHOC = () => {
    const dispatch = useDispatch();
    const orderWindow = useSelector(state => state.orders.orderWindow);
    const brokerageData = useSelector(state => state.brokerage.brokerageData);
    const {formattedWatchlists} = useSelector((state) => state.marketwatch);
    const [showBrokerageDialog, setShowBrokerageDialog] = useState(false);
    const [showOrderWindow, setShowOrderWindow] = useState(false);
    const tabLeftTime = useRef(null);

    // Close order window if user returns after 5+ seconds
    useEffect(() => {
        const onVisibilityChange = () => {
            if (document.hidden) tabLeftTime.current = Date.now();
            else if (tabLeftTime.current && orderWindow.open && Date.now() - tabLeftTime.current >= 5000) {
                dispatch(closeOrderWindow());
            }
        };
        document.addEventListener('visibilitychange', onVisibilityChange);
        return () => document.removeEventListener('visibilitychange', onVisibilityChange);
    }, [orderWindow.open, dispatch]);

    // Check if brokerage acknowledgment is needed
    useEffect(() => {
        if (orderWindow.open && orderWindow.trading_symbol && orderWindow.token) {
            const brokerageAcknowledged = localStorage.getItem('brokerage_acknowledged') === 'true';
            const hasBrokerageMessage = brokerageData?.message && brokerageData?.is_brokerage_applied;
            
            if (!brokerageAcknowledged && hasBrokerageMessage) {
                // Show brokerage dialog first
                setShowBrokerageDialog(true);
                setShowOrderWindow(false);
            } else {
                // Show order window directly
                setShowBrokerageDialog(false);
                setShowOrderWindow(true);
            }
        } else {
            // Reset states when order window closes
            setShowBrokerageDialog(false);
            setShowOrderWindow(false);
        }
    }, [orderWindow.open, orderWindow.trading_symbol, orderWindow.token, brokerageData]);

    const handleClose = () => {
        dispatch(closeOrderWindow());
        setShowBrokerageDialog(false);
        setShowOrderWindow(false);
    };

    const handleTypeChange = (newType) => {
        dispatch(updateOrderWindowType(newType));
    };

    const handleBrokerageAcknowledge = () => {
        // Close brokerage dialog and show order window
        setShowBrokerageDialog(false);
        setShowOrderWindow(true);
    };

    // Only render if we have all required data
    if (!orderWindow.open || !orderWindow.trading_symbol || !orderWindow.token) {
        return null;
    }

    return (
        <>
            {/* Brokerage Acknowledgment Dialog */}
            <BrokerageAcknowledgmentDialog
                open={showBrokerageDialog}
                onAcknowledge={handleBrokerageAcknowledge}
                brokerageMessage={brokerageData?.message}
                brokerageData={brokerageData}
            />

            {/* Order Window */}
            {showOrderWindow && (
                <OrderWindow
                    {...orderWindow}
                    formattedWatchlists={formattedWatchlists}
                    onClose={handleClose}
                    onTypeChange={handleTypeChange}
                />
            )}
        </>
    );
};

export default OrderWindowHOC; 